import { render } from "./confirm-bet.vue?vue&type=template&id=054a2ca4&scoped=true&ts=true"
import script from "./confirm-bet.vue?vue&type=script&lang=ts"
export * from "./confirm-bet.vue?vue&type=script&lang=ts"

import "./confirm-bet.vue?vue&type=style&index=0&id=054a2ca4&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054a2ca4"]])

export default __exports__